/**
 * GENERATED_ASSET — types (palette membership belongs to the shared piece registry).
 * Shapes marked "mirrors" are structurally identical to
 * Helix2000/docs/plans/2026-10-20-hush-nook-lanternskip/catalog/asset-generator-contracts.ts
 * so artifacts stay assignable to its SvgAssetArtifact without importing the canonical checkout.
 */
export interface Point2 { readonly x: number; readonly y: number }
export interface VisualBounds extends Point2 { readonly width: number; readonly height: number }
export type DetailTier = 'readable' | 'standard' | 'close';
export type { PiecePaletteId as PaletteId } from '../../../../../shared/assets/pieces/palettes';
import type { PiecePaletteId as PaletteId } from '../../../../../shared/assets/pieces/palettes';
export type PaletteRole =
  | 'outline' | 'outlineSoft' | 'paperBase' | 'paperLight' | 'paperShadow'
  | 'warmCore' | 'woodBase' | 'woodLight' | 'woodShadow'
  | 'clothBlue' | 'clothBlueLight' | 'clothBlueShadow'
  | 'reedBase' | 'reedLight' | 'reedShadow'
  | 'stoneBase' | 'stoneLight' | 'stoneShadow' | 'moss' | 'salt'
  | 'waterFar' | 'waterLight';
export type ResolvedPalette = Readonly<Record<PaletteRole, string>>;
export interface StyleProfile { // mirrors
  readonly outerStroke: number; readonly seamStroke: number; readonly grainStroke: number;
  readonly grainOpacity: number; readonly contactShadowOpacity: number;
  readonly coordinatePrecision: number; readonly samplingPadding: number;
}
export interface VisualAnchor { // mirrors
  readonly name: string; readonly point: Point2;
  readonly role: 'origin' | 'attachment' | 'support' | 'effect' | 'inspection';
}
export interface ProtectedVisualRegion { // mirrors
  readonly name: string; readonly role: 'motif' | 'face-clearance' | 'opening' | 'clear-lane';
  readonly bounds: VisualBounds; readonly gameplayAuthority: false;
}
export interface ArtifactIdentity { // mirrors
  readonly assetId: string; readonly recipeId: string; readonly generatorId: string;
  readonly generatorRevision: string; readonly logicalRecipeHash: string;
}

export type FountainVariant = 'harbor' | 'mossgrown' | 'dry_ruin';
export interface FountainParams {
  readonly variant: FountainVariant;
  readonly width: 384; readonly height: 320;
  readonly tiers: 2 | 3;
  readonly flow: number; readonly waterLevel: number;
  readonly mossCoverage: number; readonly stoneWear: number;
}
export interface FountainRecipe {
  readonly schema: 'hush.asset-recipe.v1';
  readonly id: string;
  readonly assetId: 'prop.coastal.tidal_cascade_fountain';
  readonly generatorId: 'scenery.tidal_cascade_fountain.v1';
  readonly seed: number;
  readonly paletteId: PaletteId;
  readonly detail: DetailTier;
  readonly params: Readonly<FountainParams>;
}

export type LayerId = 'body' | 'water' | 'foam' | 'spray';
export const LAYER_ORDER: readonly LayerId[] = ['body', 'water', 'foam', 'spray'];

export interface LayerArtifact {
  readonly id: LayerId;
  readonly svg: string;
  readonly svgBytesHash: string;
  readonly empty: boolean;
  readonly paintBounds: VisualBounds;
  readonly contentBounds: VisualBounds;
}

/** Painted support only: where stone actually touches the ground line. Not collision. */
export interface SupportContact {
  readonly kind: 'painted-base-contact';
  readonly point: Point2;
  readonly span: { readonly x0: number; readonly x1: number; readonly y: number };
  readonly physicalClaim: 'none';
}

export interface DisplaySpec {
  readonly designFrame: { readonly width: 384; readonly height: 320 };
  readonly proposedScale: number;
  readonly displayFrame: { readonly width: number; readonly height: number };
  readonly note: string;
}

export interface FountainArtifact extends ArtifactIdentity { // extends mirrors SvgAssetArtifact
  readonly kind: 'svg-artifact';
  readonly integration: 'GENERATED_ASSET';
  readonly svg: string;
  readonly svgBytesHash: string;
  readonly origin: { readonly kind: 'bottom-center'; readonly point: Point2 };
  readonly contentBounds: VisualBounds;
  readonly paintBounds: VisualBounds;
  readonly viewBox: VisualBounds;
  readonly anchors: readonly VisualAnchor[];
  readonly protectedRegions: readonly ProtectedVisualRegion[];
  readonly renderRole: 'back-structure';
  readonly gameplayGeometry: 'not-generated';
  readonly layers: Readonly<Record<LayerId, LayerArtifact>>;
  readonly support: SupportContact;
  readonly display: DisplaySpec;
  readonly namespace: string;
  readonly logicalSource: { readonly kind: 'recipe'; readonly recipeId: string; readonly assetId: string };
}
